import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderServiceService {

  constructor() { }


  static loadDynamicScript(url: string) {
    const body = document.body as HTMLDivElement;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  static loadDynamicLinks(url: string) {
    const body = document.body as HTMLDivElement;
    const link = document.createElement('link');
    link.innerHTML = '';
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    body.appendChild(link);
  }

  static adminScripts() {
    // jQuery
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/jQuery/jquery-1.12.4.min.js');
    // jquery-ui
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/jquery-ui-1.12.1/jquery-ui.min.js');
    // Bootstrap
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/bootstrap/js/bootstrap.min.js');
    // Datatables
    DynamicScriptLoaderServiceService.loadDynamicScript('https://cdn.datatables.net/1.10.19/js/jquery.dataTables.min.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('https://cdn.datatables.net/1.10.19/js/dataTables.bootstrap.min.js');
    // Bootstrap Datepicker
    DynamicScriptLoaderServiceService.loadDynamicScript('https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.8.0/js/bootstrap-datepicker.js');
    // lobipanel
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/lobipanel/lobipanel.min.js');
    // Pace js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/pace/pace.min.js');
    // SlimScroll
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/slimScroll/jquery.slimscroll.min.js');
    // FastClick
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/fastclick/fastclick.min.js');
    // Hadmin frame
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom1.js');
    // Toaster Js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/toastr/toastr.min.js');
    // Sparkline js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/sparkline/sparkline.min.js');
    // Data maps js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/datamaps/d3.min.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/datamaps/topojson.min.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/datamaps/datamaps.all.min.js');
    // Counter js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/counterup/waypoints.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/counterup/jquery.counterup.min.js');
    // ChartJs JavaScript
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/chartJs/Chart.min.js');
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/emojionearea/emojionearea.min.js');
    // Monthly js
    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/plugins/monthly/monthly.js');
  }


}
